import { useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { PageHeader } from "@/components/StatCard";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { toast } from "sonner";

const dur = (ms) => (ms ? `${Math.floor(ms / 60000)}:${String(Math.round((ms % 60000) / 1000)).padStart(2, "0")}` : "");

const Row = ({ c, admin }) => (
  <div className="border-t border-slate-100 py-4 text-sm" data-testid={`surety-call-${c.call_id}`}>
    <div className="flex flex-wrap items-center gap-2">
      <span className="font-semibold text-slate-900">{c.lead_name || "Contractor"}{c.business ? ` · ${c.business}` : ""}</span>
      <Badge className="border-0 bg-slate-100 capitalize text-slate-700" data-testid={`surety-call-outcome-${c.call_id}`}>{c.outcome || (c.status === "analyzed" ? "ended" : "calling...")}</Badge>
      {c.qr && <Badge variant="outline">QR scan</Badge>}
      <span className="text-xs text-slate-400">{new Date(c.created_at).toLocaleString()}{c.duration_ms ? ` · ${dur(c.duration_ms)}` : ""}{admin && c.agent_name ? ` · ${c.agent_name}` : ""}</span>
      {c.from_number && <span className="text-xs text-slate-500" data-testid={`surety-call-from-${c.call_id}`}>Called from {c.from_number.replace(/^\+1(\d{3})(\d{3})(\d{4})$/, "($1) $2-$3")}</span>}
    </div>
    {c.summary && <p className="mt-1 text-slate-700" data-testid={`surety-call-summary-${c.call_id}`}><span className="font-semibold">AI call notes: </span>{c.summary}</p>}
    {!c.summary && c.status === "analyzed" && <p className="mt-1 text-xs text-slate-400" data-testid={`surety-call-nosummary-${c.call_id}`}>No AI call notes (nobody spoke on the call)</p>}
    {c.appointment?.appointment_type && c.appointment.appointment_type !== "none" && (
      <p className="mt-1 text-emerald-700">Appointment: {c.appointment.appointment_type} {c.appointment.appointment_time} {c.appointment.appointment_address}</p>
    )}
    {c.recording_url ? <audio controls preload="none" src={c.recording_url} className="mt-2 h-9 w-full max-w-md" data-testid={`surety-call-audio-${c.call_id}`} />
      : c.status === "analyzed" && <p className="mt-1 text-xs text-slate-400" data-testid={`surety-call-norec-${c.call_id}`}>No recording (call wasn't answered)</p>}
  </div>
);

export default function SuretyCalls() {
  const [calls, setCalls] = useState(null);
  const [admin, setAdmin] = useState(false);
  useEffect(() => {
    api.get("/auth/me").then((r) => setAdmin(r.data.role === "admin")).catch(() => {});
    api.get("/surety/calls").then((r) => setCalls(r.data.calls)).catch((e) => toast.error(apiError(e)));
  }, []);
  return (
    <div data-testid="surety-calls-page">
      <PageHeader title="Call Log" subtitle="Every call Ava made to your contractors, with the recording and AI call notes." />
      <Card className="p-6">
        {calls && !calls.length && <p className="text-sm text-slate-500" data-testid="surety-calls-empty">No calls yet. Ava calls when AI dialing and Autopilot are on, or when a contractor scans your postcard.</p>}
        {calls?.map((c) => <Row key={c.call_id} c={c} admin={admin} />)}
      </Card>
    </div>
  );
}
